import { ApiTagTypes, innovorderApi } from '../index';
import { ApiRequest, ApiResponse, ApiResponseBase } from '../request.types';
import { RestaurantShift } from '../restaurant/restaurant.type';
import { DeleteShiftPayload, GetShiftPayload, PostShiftPayload, PutShiftPayload } from './shift.type';

const shiftApi = innovorderApi.injectEndpoints({
    endpoints: (build) => ({
        getShift: build.query<RestaurantShift & { brandId: number }, ApiRequest<GetShiftPayload>>({
            query: ({ shiftId, token }) => ({
                url: `/shifts/${shiftId}`,
                method: 'GET',
                headers: { authorization: `Bearer ${token}` },
            }),
            providesTags: (_result, _error, { shiftId }) => [{ type: ApiTagTypes.Shift, id: shiftId }],
            transformResponse: (response: ApiResponse<RestaurantShift & { brandId: number }>) => response.data,
            extraOptions: { maxRetries: 3 },
        }),
        postShift: build.mutation<RestaurantShift, ApiRequest<PostShiftPayload>>({
            query: ({ token, ...body }) => ({
                url: `/shifts`,
                method: 'POST',
                body,
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: [ApiTagTypes.Shift],
            transformResponse: (response: ApiResponse<RestaurantShift>) => response.data,
        }),
        putShift: build.mutation<RestaurantShift, ApiRequest<PutShiftPayload>>({
            query: ({ shiftId, token, ...body }) => ({
                url: `/shifts/${shiftId}`,
                method: 'PUT',
                body,
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: (_result, _error, { shiftId }) => [
                ApiTagTypes.Shift,
                { type: ApiTagTypes.Shift, id: shiftId },
            ],
            transformResponse: (response: ApiResponse<RestaurantShift>) => response.data,
        }),
        deleteShift: build.mutation<ApiResponseBase, ApiRequest<DeleteShiftPayload>>({
            query: ({ shiftId, token }) => ({
                url: `/shifts/${shiftId}`,
                method: 'DELETE',
                headers: { authorization: `Bearer ${token}` },
            }),
            invalidatesTags: [ApiTagTypes.Shift],
        }),
    }),
});

export const { useGetShiftQuery, usePostShiftMutation, usePutShiftMutation, useDeleteShiftMutation } = shiftApi;
